/*
 * @Description:校验名称唯一性相关api
 * @Version: 2.0
 * @Autor: 纪楠楠 jinannan@qfei.cn
 * @Date: 2024-03-21 10:22:11
 * @LastEditors: 纪楠楠 jinannan@qfei.cn
 */
import { leadsService, clientService, opportunityService } from '@/api/';
import { reactive } from 'vue';
export default function useCheckOption() {
  const datacheck = reactive({
    checkCompanyNameStatus: false,
    userinfos: []
  });
  // 线索
  const clueCheckFieldRepeat = async (e) => {
    try {
      if (!e) return { checkCompanyNameStatus: false, userinfos: [] };
      const res = await leadsService.clueCheckFieldRepeat({ companyName: e });
      datacheck.checkCompanyNameStatus = res?.result?.exist;
      datacheck.userinfos = res?.result?.followUsers;
      return datacheck;
    } catch (e) {
      console.log(265, e);
      return {};
    }
  };
  // 客户
  const customerCheckFieldRepeat = async (e) => {
    try {
      if (!e) return { status: false };
      const res = await clientService.customerCheckFieldRepeat({ customerName: e });
      datacheck.checkCompanyNameStatus = res?.result?.exist;
      datacheck.userinfos = res?.result?.chargePersons;
      return datacheck;
    } catch (e) {
      console.log(265, e);
      return {};
    }
  };
  // 商机
  const opportunityCheckFieldRepeat = async (e) => {
    try {
      if (!e) return { status: false };
      const res = await opportunityService.opportunityCheckFieldRepeat({ opportunityName: e });
      datacheck.checkCompanyNameStatus = res?.result?.exist;
      datacheck.userinfos = res?.result?.chargePersons;
      return datacheck;
    } catch (e) {
      console.log(265, e);
      return {};
    }
  };
  return {
    datacheck,
    clueCheckFieldRepeat,
    customerCheckFieldRepeat,
    opportunityCheckFieldRepeat
  };
}
